import keycloakAxios from '@/services/axios';

import {Sport} from '@/types/common';
import {env} from '@/config';

const {CONTENT_SERVER} = env;

export const findSports = async (companyId?: string) => {
  const response = await keycloakAxios.get('sport/', {
    params: companyId ? {companyId} : {}
  });

  const sports: Sport[] = response.data;
  const map: {[key: string]: Sport} = {};
  sports.forEach((sport: Sport) => {
    sport.picture = sport.picture.includes('http')
      ? sport.picture
      : `${CONTENT_SERVER}` + sport.picture;
    map[sport._id] = sport;
  });

  return map;
};
